export default (asset: string): string => {
  if (IS_SHOWROOM) {
    return asset;
  }
  return `/dist/fischer-website-rebrush/${asset}`;
};
